const accuEligibleCheck = (data) => ({
    isEligible: false,
    firstEligibleOption: {},
    canUseAccuPro: false,
    firstUsableOption: {},
    isEligibleForOptions: {},
    canUseAccuProOptions: {},
    canUseAccuProOptionsLanding: {},
    section: data.name || '',
    accuProLandingUsable: false,
    allOptions: [],
    showedOne: null,
    init() {
        this.showedOne = null
        this.accuEligible()
        this.recalcEligibility()
        this.recalcUsability()

        this.allOptions = JSON.parse(decodeURIComponent(window.accu_slide_markup))
    },
    recalcEligibility() {
        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))

        Object.keys(options).forEach((key) => {
            this.isEligibleFor(options[key].id)
        })
    },
    recalcUsability() {
        const today = new Date().getTime()
        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))

        Object.keys(options).forEach((key) => {
            this.canUseAccuProOptions[options[key].id] = false
        })

        let currenctCountry = 17

        if (window.Alpine.store('user') && window.Alpine.store('user').delivery_country_id !== null) {
            currenctCountry = window.Alpine.store('user').delivery_country_id.toString()
        }

        Object.keys(window.Alpine.store('user').accupro_subscriptions).forEach((key) => {
            if (window.Alpine.store('user').accupro_subscriptions[key].banner_country_list.split(',').includes(currenctCountry)
              && window.Alpine.store('user').accupro_subscriptions[key].end_date !== null && window.Alpine.store('user').accupro_subscriptions[key].end_date !== '0000-00-00 00:00:00'
              && new Date(window.Alpine.store('user').accupro_subscriptions[key].end_date).getTime() > today) {
                this.canUseAccuProOptions[window.Alpine.store('user').accupro_subscriptions[key].id] = new Date(window.Alpine.store('user').accupro_subscriptions[key].end_date).getTime()
            }
        })

        Object.keys(window.Alpine.store('user').accupro_subscriptions).forEach((key) => {
            if (new Date(window.Alpine.store('user').accupro_subscriptions[key].end_date).getTime() > today
              && window.Alpine.store('user').accupro_subscriptions[key].end_date !== null && window.Alpine.store('user').accupro_subscriptions[key].end_date !== '0000-00-00 00:00:00') {
                this.canUseAccuProOptionsLanding[window.Alpine.store('user').accupro_subscriptions[key].id] = new Date(window.Alpine.store('user').accupro_subscriptions[key].end_date).getTime()
            }
        })
    },
    accuEligible() {
        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))
        this.isEligible = false
        Object.keys(this.isEligibleForOptions).forEach((key) => {
            if (this.isEligibleForOptions[key] === true) {
                this.firstEligibleOption = options[key]
                this.isEligible = true
                return true
            }
        })

        return this.isEligible
    },
    eligibleOrOwnsFor(id) {
        if (this.showedOne !== null && this.showedOne !== id) {
            return false
        }

        if (this.isEligibleForOptions[id] === true || (this.canUseAccuProOptionsLanding[id] !== false && this.canUseAccuProOptionsLanding[id] !== undefined)) {
            this.showedOne = id
            return true
        }

        return false
    },
    eligibleOrOwns() {
        this.accuProLandingUsable = false

        Object.keys(this.isEligibleForOptions).forEach((key) => {
            if (this.isEligibleForOptions[key] === true) {
                this.accuProLandingUsable = true
            }
        })

        Object.keys(this.canUseAccuProOptionsLanding).forEach((key) => {
            if (this.canUseAccuProOptionsLanding[key] !== false && this.canUseAccuProOptionsLanding[key] !== undefined) {
                this.accuProLandingUsable = true
            }
        })

        return this.accuProLandingUsable
    },
    get accuNotEligible() {
        const eligibles = Object.keys(this.isEligibleForOptions).filter((key) => {
            if (this.isEligibleForOptions[key] === true) {
                return true
            }

            return false
        })

        return !(eligibles.length > 0)
    },
    canUseAccuProCheck() {
        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))

        Object.keys(this.canUseAccuProOptions).forEach((key) => {
            if (this.canUseAccuProOptions[key] !== false) {
                this.firstUsableOption = options[key]
                this.canUseAccuPro = true
                return true
            }
        })

        return this.canUseAccuPro
    },
    isEligibleFor(id, setAsFirst = false) {
        const today = new Date().getTime()
        let currenctCountry = null
        let accuproOption = {}

        const options = JSON.parse(decodeURIComponent(window.accu_slide_markup))

        Object.keys(options).forEach((key) => {
            if (parseInt(options[key].id, 10) === parseInt(id, 10)) {
                accuproOption = options[key]
                accuproOption.accuproEndDateForOption = 0
            }
        })

        Object.keys(window.Alpine.store('user').accupro_subscriptions).forEach((key) => {
            if (window.Alpine.store('user').accupro_subscriptions[key].id === id) {
              if (window.Alpine.store('user').accupro_subscriptions[key].end_date !== null && window.Alpine.store('user').accupro_subscriptions[key].end_date !== '0000-00-00 00:00:00') {
                accuproOption.accuproEndDateForOption = new Date(window.Alpine.store('user').accupro_subscriptions[key].end_date).getTime()
                }
            }
        })

        if (!accuproOption.id) {
            return false
        }

        const currency = window.Alpine.store('currency') === undefined ? window.accuvars.currency : window.Alpine.store('currency')

        if (window.Alpine.store('user') && window.Alpine.store('user').delivery_country_id !== null) {
            currenctCountry = window.Alpine.store('user').delivery_country_id.toString()
        }

        if (
            (
                accuproOption.banner_country_list.split(',').includes(currenctCountry)
                || (
                    // or cart has no delivery and language is English + currency is GBP
                    accuproOption.banner_currency_list.split(',').includes(currency.id.toString())
                    && accuproOption.banner_language_list.split(',').includes(window.accuvars.language.id.toString())
                    && window.Alpine.store('user').delivery_country_id === null
                )
            ) // and is not accupro already
            && accuproOption.accuproEndDateForOption < today
        ) {
            this.isEligibleForOptions[id] = true
            if (setAsFirst) {
                this.firstEligibleOption = accuproOption
            }
            return true
        }
        this.isEligibleForOptions[id] = false
        return false
    },
})

document.addEventListener('alpine:init', () => {
    window.Alpine.data('accuEligibleCheck', accuEligibleCheck)
})

// For use in custom scripts
window.accuEligibleCheck = accuEligibleCheck
